// src/api/verificationApi.js
import axios from 'axios';
import { Platform } from 'react-native';

const API_BASE_URL = 'https://api.taxi-yaounde.com';
// const API_BASE_URL = 'http://localhost:4000'; 


export async function uploadVerificationDocument(verificationId, docType, file, docSide = 'front') {
  if (!verificationId) throw new Error('verificationId is required');
  if (!docType) throw new Error('docType is required');
  if (!file) throw new Error('file is required');

  const url = `${API_BASE_URL}/api/verification/${verificationId}/document`;

  const formData = new FormData();
  formData.append('docType', docType);
  formData.append('docSide', docSide);

  if (Platform.OS === 'web') {
    if (file?.__webFile instanceof File) {
      formData.append('file', file.__webFile, file.__webFile.name);
    } else if (file instanceof File) {
      formData.append('file', file, file.name);
    } else if (file?.uri) {
      const res = await fetch(file.uri);
      const blob = await res.blob();
      const name = file.name || 'document';
      const type = file.mimeType || file.type || blob.type || 'application/octet-stream';
      const webFile = new File([blob], name, { type });
      formData.append('file', webFile, webFile.name);
    } else {
      throw new Error('Web upload: file must be a File or an object with { uri }');
    }

    const response = await axios.post(url, formData);
    return response.data;
  }

  if (!file?.uri) throw new Error('Native upload: file.uri is required');

  formData.append('file', {
    uri: file.uri,
    name: file.name || 'document',
    type: file.mimeType || file.type || 'application/octet-stream',
  });

  const response = await axios.post(url, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
}





// Complete verification and mark vehicle as verified
// export const completeVerification = async (verificationId, payload) => {
//   try {
//     const response = await axios.post(
//       `${API_BASE_URL}/api/verification/${verificationId}/complete`,
//       payload,
//       {
//         headers: {
//           'Content-Type': 'application/json',
//         },
//       }
//     );
//     return response.data;
//   } catch (error) {
//     console.error('Error completing verification: - verificationApi.js:94', error);
//     throw error;
//   }
// };

// src/api/verificationApi.js

// Complete verification and mark vehicle as verified
export const completeVerification = async (verificationId, payload, options = {}) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/verification/${verificationId}/complete`,
      payload,
      { headers: { 'Content-Type': 'application/json' } }
    );

    return {
      ...response.data,
    };
  } catch (error) {
    console.error('Error completing verification:', error);
    throw error;
  }
};

// Fetch QR code for a vehicle
export const fetchQRCode = async (vehicleId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/vehicles/${vehicleId}/qrcode`,
      {
        responseType: 'arraybuffer',
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching QR code: - verificationApi.js:110', error);
    throw error;
  }
};

// Fetch QR code for a driver (PNG)
export const fetchDriverQRCode = async (personId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/drivers/${personId}/qrcode`,
      { responseType: "arraybuffer" }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching driver QR code: - verificationApi.js:124", error);
    throw error;
  }
};

// Download QR code as PDF
// export const downloadQRCodePDF = async (vehicleId) => {
//   try {
//     const response = await axios.get(
//       `${API_BASE_URL}/api/vehicles/${vehicleId}/qrcode-pdf`,
//       {
//         responseType: 'blob',
//       }
//     );
//     return response.data;
//   } catch (error) {
//     console.error('Error downloading QR code PDF: - verificationApi.js:140', error);
//     throw error;
//   }
// };
export const downloadQRCodePDF = async (vehicleId) => {
  const res = await axios.get(
    `${API_BASE_URL}/api/vehicles/${vehicleId}/qrcode-pdf`,
    { responseType: "arraybuffer" }
  );
  return res.data;
};

// Check verification status
export const checkVerificationStatus = async (verificationId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/verification/${verificationId}/status`
    );
    return response.data;
  } catch (error) {
    console.error('Error checking verification status: - verificationApi.js:160', error);
    throw error;
  }
};

// Add these new API functions to your verificationApi.js

// Generate door number for a vehicle
export const generateDoorNumber = async (vehicleId) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/vehicles/${vehicleId}/generate-door-number`
    );
    return response.data;
  } catch (error) {
    console.error('Error generating door number:', error);
    throw error;
  }
};

// Download door sticker PDF
export const downloadDoorStickerPDF = async (vehicleId, size = 'standard') => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/vehicles/${vehicleId}/door-sticker-pdf`,
      {
        params: { size },
        responseType: 'arraybuffer',
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error downloading door sticker PDF:', error);
    throw error;
  }
};

// Combined function to generate door number and download sticker
export const generateAndDownloadSticker = async (vehicleId, size = 'standard') => {
  try {
    // Step 1: Generate door number (or get existing)
    const doorNumberResult = await generateDoorNumber(vehicleId);
    
    if (!doorNumberResult.success) {
      throw new Error('Failed to generate door number');
    }

    console.log('Door number:', doorNumberResult.door_number);
    console.log('Already existed:', doorNumberResult.already_exists);

    // Step 2: Download the door sticker PDF
    const pdfData = await downloadDoorStickerPDF(vehicleId, size);
    
    return {
      success: true,
      doorNumber: doorNumberResult.door_number,
      alreadyExists: doorNumberResult.already_exists,
      sequenceNumber: doorNumberResult.sequence_number,
      pdfData: pdfData,
    };
  } catch (error) {
    console.error('Error in generateAndDownloadSticker:', error);
    throw error;
  }
};